import { render } from "./OnlyLabel.vue?vue&type=template&id=7ed97b65"
import script from "./OnlyLabel.vue?vue&type=script&lang=js"
export * from "./OnlyLabel.vue?vue&type=script&lang=js"
script.render = render

export default script